"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidOxfordResponse = void 0;
const zod_1 = require("zod");
const OxfordDictionaryWordInflection = zod_1.z.object({
    grammaticalFeatures: zod_1.z
        .object({
        id: zod_1.z.string(),
        text: zod_1.z.string(),
        type: zod_1.z.string(),
    })
        .array(),
    inflectedForm: zod_1.z.string(),
});
const OxfordDictionaryWordOrExampleTranslation = zod_1.z.object({
    collocations: zod_1.z
        .object({
        id: zod_1.z.string(),
        text: zod_1.z.string(),
        type: zod_1.z.string(),
    })
        .array()
        .optional(),
    grammaticalFeatures: zod_1.z
        .object({
        id: zod_1.z.string(),
        text: zod_1.z.string(),
        type: zod_1.z.string(),
    })
        .array()
        .optional(),
    language: zod_1.z.string(),
    notes: zod_1.z
        .object({
        text: zod_1.z.string(),
        type: zod_1.z.string(),
    })
        .array()
        .optional(),
    regions: zod_1.z
        .object({
        id: zod_1.z.string(),
        text: zod_1.z.string(),
    })
        .array()
        .optional(),
    text: zod_1.z.string(),
});
const OxfordDictionaryWordExample = zod_1.z.object({
    text: zod_1.z.string(),
    translations: OxfordDictionaryWordOrExampleTranslation.array().optional(),
});
const OxfordDictionaryWordSubsense = zod_1.z.object({
    domains: zod_1.z
        .object({
        id: zod_1.z.string(),
        text: zod_1.z.string(),
    })
        .array()
        .optional(),
    examples: OxfordDictionaryWordExample.array().optional(),
    id: zod_1.z.string(),
    translations: OxfordDictionaryWordOrExampleTranslation.array().optional(),
});
const OxfordDictionaryWordSense = zod_1.z.object({
    crossReferenceMarkers: zod_1.z.string().array().optional(),
    crossReferences: zod_1.z
        .object({
        id: zod_1.z.string(),
        text: zod_1.z.string(),
        type: zod_1.z.string(),
    })
        .array()
        .optional(),
    examples: OxfordDictionaryWordExample.array().optional(),
    id: zod_1.z.string(),
    inflections: OxfordDictionaryWordInflection.array().optional(),
    notes: zod_1.z
        .object({
        text: zod_1.z.string(),
        type: zod_1.z.string(),
    })
        .array()
        .optional(),
    registers: zod_1.z
        .object({
        id: zod_1.z.string(),
        text: zod_1.z.string(),
    })
        .array()
        .optional(),
    subsenses: OxfordDictionaryWordSubsense.array().optional(),
    translations: OxfordDictionaryWordOrExampleTranslation.array().optional(),
});
const OxfordDictionaryWordEntry = zod_1.z.object({
    grammaticalFeatures: zod_1.z
        .object({
        id: zod_1.z.string(),
        text: zod_1.z.string(),
        type: zod_1.z.string(),
    })
        .array()
        .optional(),
    notes: zod_1.z
        .object({
        text: zod_1.z.string(),
        type: zod_1.z.string(),
    })
        .array()
        .optional(),
    pronunciations: zod_1.z
        .object({
        phoneticNotation: zod_1.z.string(),
        phoneticSpelling: zod_1.z.string(),
    })
        .array()
        .optional(),
    senses: OxfordDictionaryWordSense.array(),
});
const OxfordDictionaryWordLexicalEntry = zod_1.z.object({
    entries: OxfordDictionaryWordEntry.array(),
    language: zod_1.z.string(),
    lexicalCategory: zod_1.z.object({
        id: zod_1.z.string(),
        text: zod_1.z.string(),
    }),
    text: zod_1.z.string(),
});
const OxfordDictionaryWordResult = zod_1.z.object({
    id: zod_1.z.string(),
    language: zod_1.z.string(),
    lexicalEntries: OxfordDictionaryWordLexicalEntry.array(),
    type: zod_1.z.string(),
    word: zod_1.z.string(),
});
const OxfordDictionaryWordResponse = zod_1.z.object({
    id: zod_1.z.string(),
    metadata: zod_1.z.object({
        operation: zod_1.z.string(),
        provider: zod_1.z.string(),
        schema: zod_1.z.string(),
    }),
    results: OxfordDictionaryWordResult.array(),
    word: zod_1.z.string(),
});
const isValidOxfordResponse = (x) => OxfordDictionaryWordResponse.safeParse(x).success;
exports.isValidOxfordResponse = isValidOxfordResponse;
//# sourceMappingURL=oxford_api.js.map